import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { afterItems, beforeItems } from "../../data/landingContent";
export function BeforeAfterSection() {
  return <section className="bg-cream px-4 pb-14 sm:pb-20" data-id="element-85" data-mp="3agis7fhvuuca">
      <div className="mx-auto grid max-w-5xl grid-cols-1 gap-5 md:grid-cols-2" data-id="element-86" data-mp="3ahtrb20dvdx2">
        <div className="rounded-3xl border-2 border-red-200 bg-red-50 p-5 sm:p-7" data-id="element-87" data-mp="3fgmx089fi0mo">
          <h3 className="flex items-center gap-2.5 font-serif text-2xl font-bold text-red-800" data-id="element-88" data-mp="6z8x8zy8gsn2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-red-600" data-id="element-89" data-mp="bxahvpbb500n">
              <XIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-90" data-mp="3tdsb8vjaq5t0" />
            </span>
            Before Menopause Decision Map™
          </h3>
          <ul className="mt-5 space-y-3" data-id="element-91" data-mp="pxuzii5hkpsk">
            {beforeItems.map(item => <li key={item} className="flex gap-3 rounded-xl bg-white p-3.5 text-[16px] leading-snug text-ink" data-id="element-92" data-mp="pvs2vf9tvyev">
                <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-600" aria-hidden="true" data-id="element-93" data-mp="22nur1u5my8mv" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl border-2 border-green-300 bg-green-50 p-5 sm:p-7" data-id="element-94" data-mp="1xn6pwfnp0bex">
          <h3 className="flex items-center gap-2.5 font-serif text-2xl font-bold text-green-800" data-id="element-95" data-mp="2cf8olwe10ydd">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-cta" data-id="element-96" data-mp="27lw683zxxnt2">
              <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-97" data-mp="2lcrb757bjkrd" />
            </span>
            With Menopause Decision Map™
          </h3>
          <ul className="mt-5 space-y-3" data-id="element-98" data-mp="2vdbeseib91cr">
            {afterItems.map(item => <li key={item} className="flex gap-3 rounded-xl bg-white p-3.5 text-[16px] leading-snug text-ink" data-id="element-99" data-mp="2qdyi721n0fwz">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-100" data-mp="10y8viyjuufia" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <CtaButton className="mt-10" label="I want a clearer clinical workflow" subtext="Instant Access · Complete Digital Collection · $27" data-id="element-101" data-mp="1lo2yveo879ao" />
    </section>;
}